import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useUsersAuthzAPIUserPermissionsReadCheckUserPermission } from '@mi-front/api-clients';
import { UserRole } from '@mi-front/core';
import { useAuth } from '../../authentication/hooks/useAuth';

export function useHasPermission(permission: string): boolean | undefined {
  const auth = useAuth();
  const permissionsEnabled = useFeatureIsOn('app__user_permissions_check');

  // Check if we need to verify permission (only for CLIENT_USER)
  const shouldCheckPermission = permissionsEnabled && auth.user.role === UserRole.CLIENT_USER;

  // For CLIENT_USER, check permission against UsersAuthz API
  const permissionCheck = useUsersAuthzAPIUserPermissionsReadCheckUserPermission(permission, {
    query: {
      enabled: shouldCheckPermission,
    },
  });

  // If user is not CLIENT_USER, grant permission automatically
  if (!shouldCheckPermission) {
    return true;
  }

  return permissionCheck.data?.hasPermission;
}
